import PropTypes from 'prop-types';
import React from 'react';
import { GroupListItem } from './GroupListItem';


export class GroupList extends React.Component {
  render() {
    const { subGroups } = this.props;

    return (
      <div>
      {
        Object.keys(subGroups).map((group, index) => [
          <li className="list-group-item list-group-item-header" key={'list_item-' + index}>{group}</li>,
          subGroups[group].map((groupItem, idx) => <GroupListItem key={ index + '-' + idx } {...groupItem} />),
        ])
      }
      </div>
    );
  }
}

GroupList.propTypes = {
  subGroups: PropTypes.object,
  groupIndex: PropTypes.number,
  groupTitle: PropTypes.string,
};
